import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    // Data
    files: [],
    totalElements: 0,

    // Filter options
    firms: [],

    // Loading
    loading: false,
    error: null,

    // Preview
    previewUrl: null,
    openPreview: false,
    previewRow: null,

    // Details dialog
    detailsRow: null,
};

const namingIssueSlice = createSlice({
    name: 'namingIssue',
    initialState,
    reducers: {
        loadingStarted(state) {
            state.loading = true;
            state.error = null;
        },
        loadingStopped(state) {
            state.loading = false;
        },
        loadingFailed(state, action) {
            state.loading = false;
            state.error = action.payload.error;
        },
        filesLoaded(state, action) {
            state.files = action.payload.files;
            state.totalElements = action.payload.total;
        },
        firmsLoaded(state, action) {
            state.firms = action.payload.firms.sort((a, b) =>
                a.localeCompare(b, undefined, { sensitivity: 'base' })
            );
        },
        previewOpened(state, action) {
            state.previewUrl = action.payload.url;
            state.previewRow = action.payload.row;
            state.openPreview = true;
        },
        previewClosed(state) {
            state.previewUrl = null;
            state.previewRow = null;
            state.openPreview = false;
        },
        detailsOpened(state, action) {
            state.detailsRow = action.payload.row;
        },
        detailsClosed(state) {
            state.detailsRow = null;
        },
    },
});

export const { actions: namingIssueActions } = namingIssueSlice;
export const namingIssueReducer = namingIssueSlice.reducer;

